import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import { ApplicationLoader } from 'components/ApplicationLoader';
import { ModalProvider } from 'features/Modals';
import { setupVirtualBackgrounds } from 'features/VirtualBackground/hooks/useVirtualBackgrounds';
import { ErrorPage } from 'pages/ErrorPage';
import { MainPage } from 'pages/MainPage/MainPage';
import { RecordPage } from 'pages/RecordPage';
import { TestSortPage } from 'pages/TestSortPage/TestSortPage';
import { useAuthorize } from 'useCase/app/useAuthorize';
import { fetchFeatureFlags } from 'useCase/featureFlags/featureFlagsApi';
import { observer } from 'mobx-react-lite';
import { Container } from './view';

const AppRouter = observer(() => {
    const [isLoading, setIsLoading] = useState(true);

    const { isProcessingCompleted } = useAuthorize();

    useEffect(() => {
        (async () => {
            if (isProcessingCompleted) {
                await fetchFeatureFlags();
                await setupVirtualBackgrounds();

                setIsLoading(false);
            }
        })();
    }, [fetchFeatureFlags, isProcessingCompleted]);

    if (isLoading) {
        return (
            <Container>
                <ApplicationLoader />
            </Container>
        );
    }

    const isTestPageShown = process.env.NODE_ENV === 'development';

    return (
        <Container id="modal-root">
            <Switch>
                {isTestPageShown && <Route path="/test_sort" component={TestSortPage} />}
                <Redirect from="/call/:roomName" to="/:roomName" />
                <Route path="/error/:errorType" component={ErrorPage} />
                <Route path="/:roomName" component={MainPage} />
                <Route path="*" component={ErrorPage} />
            </Switch>

            <ModalProvider />
        </Container>
    );
});

export const AppRoot = () => (
    <Router>
        <Switch>
            <Route exact path="/record" component={RecordPage} />
            <Route component={AppRouter} />
        </Switch>
    </Router>
);
